module.exports = __webpack_public_path__ + "static/wolfs-gravestone-958a6c3100c78e7d93661c00e9f99ee2.png";